import { Save, Search } from "@mui/icons-material";
import { Box, Grid, Table, Typography } from "@mui/material";
import useApi from "_api/index";
import TableReport from "components/Car/TableReport";
import CustomizeDatePicker from "components/DatePicker";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import CustomTable from "components/TableExplanded/TableSpecial";
import React, { useEffect } from "react";
import {
  formatCurrency2Digit,
  formatDateMonthYear,
} from "utils/helpers/format";

const columns = [];
const IncomeExpensesCar = () => {
  const [loading, setLoading] = React.useState(false);
  const [datas, setDatas] = React.useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await useApi.car_report.getAllOrderAccount();
      console.log("response", response);
      if (response.data) {
        const { data } = response;

        let remaining = 0;
        // เรียง data ใหม่ให้จากเก่าไปใหม่ก่อน
        let tempData = data.sort(
          (a, b) => new Date(a.created_date) - new Date(b.created_date)
        );
        // คำนวณค่า remaining สำหรับแต่ละแถวของ tempData
        const dataWithRemaining = tempData.map((item) => {
          remaining += Number(item.revenue) - Number(item.expenditure);
          return { ...item, remaining };
        });

        // เรียง data ใหม่กลับเป็นจากใหม่ไปเก่าตามเดิม
        dataWithRemaining.sort(
          (a, b) => new Date(b.created_date) - new Date(a.created_date)
        );
        setDatas(dataWithRemaining);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "32px" }}>รายรับ - รายจ่าย</Typography>
        <GradientButton
          sx={{
            px: 3,
            display: "flex",
            alignItems: "center",
            height: "48px",
          }}
          endIcon={<Save fontSize="medium" />}
        >
          ส่งออก Excel
        </GradientButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{ marginBottom: "8px", alignItems: "center" }}
        >
          <Grid item xs={12} sm={1} sx={{ textAlign: "right" }}>
            <Typography style={{ fontSize: "16px" }}>วันที่:</Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <CustomizeDatePicker value={null} onChange={() => {}} />
          </Grid>
          <Grid item xs={12} sm={1} sx={{ textAlign: "center" }}>
            <Typography style={{ fontSize: "16px" }}>-</Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <CustomizeDatePicker value={null} onChange={() => {}} />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "100%",
            gap: 2,
            mt: 2,
          }}
        >
          <GradientButtonOutline
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "40px",
            }}
          >
            ล้าง
          </GradientButtonOutline>
          <GradientButton
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "40px",
            }}
            endIcon={<Search />}
          >
            ค้นหา
          </GradientButton>
        </Box>
      </Box>
      <TableReport
        loading={loading}
        data={datas}
        columns={[
          { label: "ลำดับ", field: "id", render: (row, index) => index + 1 },
          {
            label: "วัน เดือน ปี",
            field: "created_date",
            render: (row) => formatDateMonthYear(row.created_date),
          },
          { label: "รหัสรายการ", field: "order_code" },
          {
            label: "ราคาทุน",
            field: "cost_price",
            render: (row) => formatCurrency2Digit(row.cost_price),
          },
          {
            label: "รายรับ",
            field: "revenue",
            render: (row) => formatCurrency2Digit(row.revenue),
          },
          {
            label: "รายจ่าย",
            field: "expenditure",
            render: (row) => formatCurrency2Digit(row.expenditure),
          },
          {
            label: "กำไรจากยอดขาย",
            field: "profit_from_selling",
            render: (row) => formatCurrency2Digit(row.profit_from_selling),
          },
          {
            label: "กำไรจากดอกเบี้ย",
            field: "profit_from_interest",
            render: (row) => formatCurrency2Digit(row.profit_from_interest),
          },
          {
            label: "กำไรจากค่าปรับ",
            field: "profit_from_penalty",
            render: (row) => formatCurrency2Digit(row.profit_from_penalty),
          },
          {
            label: "รวมกำไร",
            field: "profit_sum",
            render: (row) =>
              formatCurrency2Digit(
                Number(row.profit_from_selling) +
                  Number(row.profit_from_interest) +
                  Number(row.profit_from_penalty)
              ),
          },
          {
            label: "คงเหลือ",
            field: "remaining",
            render: (row) => formatCurrency2Digit(row.remaining),
          },
        ]}
        lastRow={{
          id: "",
          created_date: "",
          order_code: "รวมทั้งสิ้น",
          cost_price: formatCurrency2Digit(
            datas.reduce((sum, r) => sum + Number(r.cost_price || 0), 0)
          ),
          revenue: formatCurrency2Digit(
            datas.reduce((sum, r) => sum + Number(r.revenue || 0), 0)
          ),
          expenditure: formatCurrency2Digit(
            datas.reduce((sum, r) => sum + Number(r.expenditure || 0), 0)
          ),
          profit_from_selling: formatCurrency2Digit(
            datas.reduce(
              (sum, r) => sum + Number(r.profit_from_selling || 0),
              0
            )
          ),
          profit_from_interest: formatCurrency2Digit(
            datas.reduce(
              (sum, r) => sum + Number(r.profit_from_interest || 0),
              0
            )
          ),
          profit_from_penalty: formatCurrency2Digit(
            datas.reduce(
              (sum, r) => sum + Number(r.profit_from_penalty || 0),
              0
            )
          ),
          profit_sum: formatCurrency2Digit(
            datas.reduce(
              (sum, r) =>
                sum +
                Number(r.profit_from_selling || 0) +
                Number(r.profit_from_interest || 0) +
                Number(r.profit_from_penalty || 0),
              0
            )
          ),
          remaining: formatCurrency2Digit(
            datas.length ? datas[0].remaining : 0 // หรือจะ sum ทั้งหมดก็ได้
          ),
        }}
      />

      {/* <CustomTable data={datas} columns={columns} /> */}
    </Box>
  );
};

export default IncomeExpensesCar;
